import {Language} from '../enums/language.enum';

/**
 * Constant: Field names carrying the question text per language on a question record
 */
export const QUESTION_NAME_FIELD = {
  GERMAN: 'germanQuestion',
  FRENCH: 'frenchQuestion',
  ENGLISH: 'englishQuestion',
  ITALIAN: 'italianQuestion',
} as const;

export type QuestionNameField = typeof QUESTION_NAME_FIELD[keyof typeof QUESTION_NAME_FIELD];

/**
 * Constant: Question text field to read for each application language
 */
export const QUESTION_NAME_FIELD_BY_LANGUAGE: Record<Language, QuestionNameField> = {
  [Language.en]: QUESTION_NAME_FIELD.ENGLISH,
  [Language.de]: QUESTION_NAME_FIELD.GERMAN,
  [Language.fr]: QUESTION_NAME_FIELD.FRENCH,
  [Language.it]: QUESTION_NAME_FIELD.ITALIAN,
};
